import { commonParams } from "../endpoint/EndpointParameters";
import { de_GetProductListCommand, se_GetProductListCommand, } from "../protocols/Aws_restJson1";
import { getEndpointPlugin } from "@smithy/middleware-endpoint";
import { getSerdePlugin } from "@smithy/middleware-serde";
import { Command as $Command } from "@smithy/smithy-client";
export { $Command };
export class GetProductListCommand extends $Command.classBuilder()
    .ep(commonParams)
    .m(function (Command, cs, config, o) {
    return [
        getSerdePlugin(config, this.serialize, this.deserialize),
        getEndpointPlugin(config, Command.getEndpointParameterInstructions()),
    ];
})
    .s("TempeFabricationPublic", "GetProductList", {})
    .n("TempeFabricationPublicClient", "GetProductListCommand").f(void 0, void 0)
    .ser(se_GetProductListCommand)
    .de(de_GetProductListCommand)
    .build() {
}
